module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/transactions/transactions.component.scss
// module id = ./src/app/routes/transactions/transactions.component.scss
// module chunks = 9